import styled from 'styled-components'
import { Link } from 'react-router'
// themes
import colors from 'themes/colors'

export const RiskLink = styled(Link)`
  pointer-events: all;
  color: ${colors.blue300};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
